const UserOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M3.00002 16.3631C3.45195 16.5 4.06237 16.5 5.1 16.5H12.9C13.9376 16.5 14.548 16.5 15 16.3631M3.00002 16.3631C2.90312 16.3337 2.8135 16.2981 2.72852 16.2548C2.30516 16.039 1.96095 15.6948 1.74524 15.2715C1.5 14.7902 1.5 14.1601 1.5 12.9V5.1C1.5 3.83988 1.5 3.20982 1.74524 2.72852C1.96095 2.30516 2.30516 1.96095 2.72852 1.74524C3.20982 1.5 3.83988 1.5 5.1 1.5H12.9C14.1601 1.5 14.7902 1.5 15.2715 1.74524C15.6948 1.96095 16.039 2.30516 16.2548 2.72852C16.5 3.20982 16.5 3.83988 16.5 5.1V12.9C16.5 14.1601 16.5 14.7902 16.2548 15.2715C16.039 15.6948 15.6948 16.039 15.2715 16.2548C15.1865 16.2981 15.0969 16.3337 15 16.3631M3.00002 16.3631C3.00026 15.7561 3.0039 15.4349 3.05764 15.1647C3.29436 13.9747 4.22466 13.0444 5.41473 12.8076C5.70453 12.75 6.05302 12.75 6.75 12.75H11.25C11.947 12.75 12.2955 12.75 12.5853 12.8076C13.7753 13.0444 14.7056 13.9747 14.9424 15.1647C14.9961 15.4349 14.9997 15.7561 15 16.3631M12 7.125C12 8.78185 10.6569 10.125 9 10.125C7.34315 10.125 6 8.78185 6 7.125C6 5.46815 7.34315 4.125 9 4.125C10.6569 4.125 12 5.46815 12 7.125Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserOutlined;
